
<form class="form-inline">
	<div class="form-group" *ngIf="dateInput">
		<div class="input-group">
		<input class="form-control" [required]="dateInput.required" [disabled]="dateInput.disabled || isDisabledNomination" [placeholder]="dateInput.placeholder" [minDate] = "dateInput.minDate"
		[maxDate]="dateInput.maxDate" (document:click)="onDatePickerClick(d)" [markDisabled]="getDisabledDates()" (click)="d.toggle(); onBlur(); $event.stopPropagation();" (blur)="onBlur()" [value]="dateInput.value | date: 'yyyy-MM-dd'"
				name="dp" [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker" (ngModelChange)="onDateChange()"
				readonly>
		<div class="input-group-append">
			<button class="btn btn-outline-secondary calendar input-group-append" (document:click)="onDatePickerClick(d)" (click)="d.toggle(); $event.stopPropagation();" type="button">
				<span class="input-group-text">
					<i class="la la-calendar"></i>
				</span>
			</button>
		</div>
		</div>
	</div>
	<p class="error-msg" *ngIf="(dateInput?.required && displayError && !model)">{{dateInput.errorMessage}}</p>
</form>
<!-- <div class="input-group">
	<input class="form-control"  (click)="datepicker.toggle();$event.stopPropagation();" (document:click)="onDatePickerClick(datepicker)"
	  [minDate]="minDateForDateInput" [maxDate]="maxDateForDateInput" [placeholder]="info.isChecked === true ? info.paymentDate: 'MM/DD/YYYY'"
	  [(ngModel)]="info.paymentDate" [disabled]="!info.isChecked" ngbDatepicker id={{info.invoiceId}}
	   #datepicker="ngbDatepicker">
	<div class="input-group-append">
	  <span class="input-group-text"><i class="fa fa-calendar-alt"></i></span>
	</div>
  </div> -->


<!-- <input class="form-control" *ngIf="dateInput" [disabled]="dateInput.disabled" [readonly]="dateInput.readonly"
[minDate]="dateInput.minDate" [maxDate]="dateInput.maxDate" [markDisabled]="getDisabledDates()"
	[placeholder]="dateInput.placeholder" name="dp" [(ngModel)]="model" (change)="onDateChange($event)" ngbDatepicker #d="ngbDatepicker"> -->
